import React from 'react';

import { Helmet } from 'react-helmet';

type SeoMetaTagsProps = {
  title: string;
  description: string;
  keywords?: string;
  author?: string;
  robots?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
};

/**
 * @description
 * SEO 메타데이터를 렌더링하는 공통 컴포넌트입니다.
 * react-helmet을 사용하여 페이지의 메타데이터를 설정합니다.
 */
function SeoMetaTags({
  title,
  description,
  keywords,
  author,
  robots,
  ogTitle,
  ogDescription,
  ogType,
  ogUrl,
  twitterCard,
  twitterTitle,
  twitterDescription,
}: SeoMetaTagsProps) {
  return (
    <Helmet>
      {/* 기본 메타 태그 */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
      {robots && <meta name="robots" content={robots} />}

      {/* Open Graph 메타 태그 */}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {ogType && <meta property="og:type" content={ogType} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}

      {/* Twitter Card 메타 태그 */}
      {twitterCard && <meta name="twitter:card" content={twitterCard} />}
      {twitterTitle && <meta name="twitter:title" content={twitterTitle} />}
      {twitterDescription && <meta name="twitter:description" content={twitterDescription} />}

      {/* 추가 메타 태그들 */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta charSet="utf-8" />

      {/* 브랜드 관련 메타 태그 */}
      <meta name="application-name" content="CheckmateKorea" />
      <meta name="apple-mobile-web-app-title" content="CheckmateKorea" />

      {/* 색상 테마 */}
      <meta name="theme-color" content="#FF2D2E" />
      <meta name="msapplication-TileColor" content="#FF2D2E" />
    </Helmet>
  );
}

export default SeoMetaTags;
